import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedSocieteEspaceService } from './societe-espace-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteEspaceService extends GeneratedSocieteEspaceService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
